/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsCreatePolicyGrant } from "../funcs/agentsCreatePolicyGrant.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AgentPolicyGrant } from "../models/components/agentpolicygrant.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateAgentPolicyGrantRequest,
  CreateAgentPolicyGrantSecurity,
} from "../models/operations/createagentpolicygrant.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type AgentsCreatePolicyGrantMutationVariables = {
  request: CreateAgentPolicyGrantRequest;
  security?: CreateAgentPolicyGrantSecurity | undefined;
  options?: RequestOptions;
};

export type AgentsCreatePolicyGrantMutationData = AgentPolicyGrant;

export type AgentsCreatePolicyGrantMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createPolicyGrant agents
 */
export function useAgentsCreatePolicyGrantMutation(
  options?: MutationHookOptions<
    AgentsCreatePolicyGrantMutationData,
    AgentsCreatePolicyGrantMutationError,
    AgentsCreatePolicyGrantMutationVariables
  >,
): UseMutationResult<
  AgentsCreatePolicyGrantMutationData,
  AgentsCreatePolicyGrantMutationError,
  AgentsCreatePolicyGrantMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildAgentsCreatePolicyGrantMutation(client, options),
    ...options,
  });
}

export function mutationKeyAgentsCreatePolicyGrant(): MutationKey {
  return ["@gram/client", "agents", "createPolicyGrant"];
}

export function buildAgentsCreatePolicyGrantMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: AgentsCreatePolicyGrantMutationVariables,
  ) => Promise<AgentsCreatePolicyGrantMutationData>;
} {
  return {
    mutationKey: mutationKeyAgentsCreatePolicyGrant(),
    mutationFn: function agentsCreatePolicyGrantMutationFn({
      request,
      security,
      options,
    }): Promise<AgentsCreatePolicyGrantMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsCreatePolicyGrant(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
